import React from 'react';

import PrimaryButton from './primaryButton';

const ChangePwdResult = ({ icon, pwdModified, onClick, text = 'Volver al inicio' }) => (
  <div className='flex w-full h-full items-center justify-between sm:justify-around flex-col '>
    <div className='flex flex-col items-center mt-20 '>
      {icon}
      <p className='font-manrope font-bold font-base text-xl leading-5 text-gray-900 text-center mt-5 px-3 md:px-20 '>{pwdModified}  </p>
    </div>

    <div className='w-full md:max-w-sm'>
      <PrimaryButton primaryButtonFunction={() => onClick()} className='px-3' buttonText={text} type='button' />
    </div>
  </div>

)
export default ChangePwdResult;
